module.exports = __webpack_public_path__ + "static/img/color-style@m.6b70b58.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/color-style@m.png
// module id = X1q7
// module chunks = 0